<template>
  <div class="shell-page">
    <HeaderMain />

    <section class="legal-shell">
      <div class="glass-surface legal-card">
        <div class="section-heading">
          <span class="section-heading__eyebrow">Atencion y soporte</span>
          <h1 class="section-heading__title">Contacto</h1>
          <p class="section-heading__text">
            Estos son los canales publicos para resolver compras, pagos, accesos, incidencias de eventos y consultas generales sobre la plataforma.
          </p>
        </div>

        <div class="legal-card__content">
          <section class="legal-page__highlight">
            <span class="legal-page__pill">Canales oficiales</span>
            <h2 class="legal-page__highlight-title">Soporte visible para clientes, organizadores y procesadores de pago</h2>
            <p>
              FOMOPLANES es operado por GINGO ENTERPRISES LLC. Direccion comercial registrada: 1209 MOUNTAIN ROAD PL NE STE R, ALBUQUERQUE, NM 87110, Estados Unidos.
            </p>
          </section>

          <div class="legal-page__meta-grid">
            <article class="legal-page__meta-card">
              <h2>Correo oficial</h2>
              <p>Consultas sobre compras, tickets, pagos y soporte general.</p>
              <a href="mailto:fomoplanes@sudenec.com">fomoplanes@sudenec.com</a>
            </article>

            <article class="legal-page__meta-card">
              <h2>Operador legal</h2>
              <p>Entidad juridica responsable de la operacion comercial y de cumplimiento de FOMOPLANES.</p>
              <p>GINGO ENTERPRISES LLC</p>
              <p>Empresa registrada en Estados Unidos</p>
            </article>

            <article class="legal-page__meta-card">
              <h2>Direccion comercial</h2>
              <p>1209 MOUNTAIN ROAD PL NE STE R</p>
              <p>ALBUQUERQUE, NM 87110</p>
              <p>ESTADOS UNIDOS</p>
            </article>

            <article class="legal-page__meta-card">
              <h2>Organiza tu evento</h2>
              <p>Si quieres vender entradas o lanzar una experiencia en la plataforma, revisa nuestra pagina para organizadores.</p>
              <router-link :to="{ name: 'launch-event' }">Lanza tu evento</router-link>
            </article>
          </div>

          <section class="legal-page__section">
            <h2>1. Para soporte de compras</h2>
            <p>
              Incluye el nombre del comprador, correo asociado a la orden, evento, numero de pedido y una descripcion clara de la incidencia. Esto ayuda a validar tu caso mas rapido.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>2. Para consultas de pagos o cargos</h2>
            <p>
              Si tu consulta esta relacionada con Stripe u otro procesador, incluye fecha aproximada, monto, ultimos cuatro digitos del medio de pago si aplica y cualquier captura relevante del error o comprobante.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>3. Para organizadores y alianzas</h2>
            <p>
              Puedes usar los canales publicados en esta pagina o la ruta para lanzamiento de eventos cuando necesites coordinar disponibilidad, activaciones, operaciones comerciales o revisiones de una experiencia.
            </p>
          </section>

          <div class="legal-page__actions">
            <router-link :to="{ name: 'terms' }">Terminos y condiciones</router-link>
            <router-link :to="{ name: 'privacy' }">Politica de privacidad</router-link>
            <router-link :to="{ name: 'refunds' }">Reembolsos y cancelaciones</router-link>
            <router-link :to="{ name: 'company' }">Compania</router-link>
          </div>
        </div>
      </div>
    </section>

    <FooterMain />
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'

export default {
  name: 'ContactView',

  components: {
    HeaderMain,
    FooterMain,
  },
}
</script>

<style>
</style>
